export enum AmpProduct {
    CategoryPageBanner = 'Category Page Banner',
    FeaturedAuctions = 'Featured Auctions',
    LeaderboardAd = 'Leaderboard Ad',
    SearchPageBanner = 'Search Page Banner',
}
